import { render, staticRenderFns } from "./ManualAllocationDashboard.vue?vue&type=template&id=5cacbb41&scoped=true&"
import script from "./ManualAllocationDashboard.vue?vue&type=script&lang=js&"
export * from "./ManualAllocationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ManualAllocationDashboard.vue?vue&type=style&index=0&id=5cacbb41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cacbb41",
  null
  
)

component.options.__file = "ManualAllocationDashboard.vue"
export default component.exports